@if (!trackMouse) {
  <canvas #canvas draggable="true" class="wm-canvas"></canvas>
}
